import { render, staticRenderFns } from "./CveCard.vue?vue&type=template&id=65c17787&scoped=true"
import script from "./CveCard.vue?vue&type=script&lang=js"
export * from "./CveCard.vue?vue&type=script&lang=js"
import style0 from "./CveCard.vue?vue&type=style&index=0&id=65c17787&prod&lang=css"
import style1 from "./CveCard.vue?vue&type=style&index=1&id=65c17787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c17787",
  null
  
)

export default component.exports